'use client';

import { ModelDisplay } from '@/shared';
import ImgClient from "@/components/private/image-client";
import { useNavigation } from '@/app/navigation-context';

export function ModelElement({ model, sizes, }: { model: ModelDisplay, sizes?: string }) {
  const href = model?.slug ? `/model/${model.slug}` : ``;
  const { loadingHref, navigate, } = useNavigation();
  const isLoading = loadingHref === href;

  if (!model?.slug) {
    console.log(`Missing model slug`);
    return <></>;
  }

  if (!model?.portrait) {
    console.log(`Missing model portrait`);
    return <></>;
  }

  return (
    <a href={href} onClick={(e) => { e.preventDefault(); navigate(href); }} style={{ position: `relative`, }}>
      {isLoading && (
        <div className="nav-loading-overlay">
          <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full" />
        </div>
      )}
      <ImgClient
        image={model.portrait}
        signedUrls={model.portrait.signedUrls}
        placeholder={model.portrait.placeholder ?? ``}
        sizes={sizes} />
      <p>{model.name}</p>
    </a>
  );
}
